import Button from "./Button";
import { useState } from "react";
import { useSelector } from "react-redux";

const SyllabusCSV = (props) => {
  const [showModal, setShowModal] = useState(false);
  const isLoading = useSelector((state) => state.search.loadingDownload);
  const downloadProgress = useSelector(
    (state) => state.search.downloadProgress
  );
  const btnHandler = (val) => {
    props.buttonHandler(val);
  };
  return (
    <div className="w-full border-[0.5px] border-black border-solid flex flex-row justify-between px-5 lg:px-10 items-center py-4">
      <span>Test Mode</span>
      <div className="flex flex-row items-center">
        <Button label="downloads" action={() => setShowModal(true)} />
      </div>
      {showModal && (
        <div className="fixed h-screen w-screen bg-slate-600/50 top-0 left-0 flex items-center justify-center z-50">
          <div className="bg-white p-8 w-[50vw] h-[30vh] border-2 border-solid border-primary shadow-[5px_5px_black]	flex flex-col justify-center items-center">
            You are about to generate a CSV/JSON with the results of your query.
            This process may take a while.
            {!isLoading ? (
              <div className="my-2">
                <Button
                  label="download JSON"
                  action={() => btnHandler(false)}
                />
                <Button label="download CSV" action={() => btnHandler(true)} />
              </div>
            ) : (
              <div className="my-2 w-full h-11 border-primary border-2 border-solid relative">
                <div
                  className="h-full bg-primary absolute left-0 transition-all transition-400"
                  style={{ width: `${downloadProgress}%` }}
                ></div>
              </div>
            )}
            <Button
              label="cancel"
              action={() => setShowModal(false)}
              isDanger={true}
            />
          </div>
        </div>
      )}
    </div>
  );
};
export default SyllabusCSV;
